import React from "react"
import { useNavigate } from "react-router-dom"

const DOMAINS = [
  { num: "01", title: "Biological Age", desc: "How well your body is functioning right now compared to your actual age." },
  { num: "02", title: "Energy Management", desc: "The ability to build and sustain physical, cognitive, and emotional energy." },
  { num: "03", title: "Strategic Recovery", desc: "The ability to deliberately restore body and brain after sustained demand." },
  { num: "04", title: "Mental Agility", desc: "The capacity to think clearly, adapt, and perform under pressure." },
  { num: "05", title: "Satisfaction with Life", desc: "An overall sense of meaning, purpose, and fulfilment, reported separately as a standalone indicator." }
]

function AboutLiveLifeV2() {
  const navigate = useNavigate()
  return (
    <div className="dashboard-body about-pq">
      <div className="container dashboard pb-5">
        <div className="d-flex align-items-center my-4">
          <button type="button" className="btn btn-outline-main" onClick={() => navigate(-1)}>Back</button>
        </div>

        <div className="dash-row card">
          <div className="card-body">
            <h1 className="mb-1 text-uppercase">What is PQ</h1>
            <p className="mb-4 text-dark-brand font-weight-bold">A new measure for a new era of performance.</p>
            <p>
              {"For decades, IQ defined intelligence. EQ extended it to emotion and connection. PQ is the "}
              <strong>missing quotient — a measure</strong>
              {" of how you perform under pressure, and how well you sustain it."}
            </p>

            <div className="row mt-4 mb-4">
              <div className="col-md-4 mb-3">
                <div className="quotient-card border">
                  <small className="quotient-card-era">1960s</small>
                  <div className="quotient-card-letter text-dark-brand">IQ</div>
                  <small className="quotient-card-label text-muted">Intelligence Quotient</small>
                  <p className="mt-2 mb-0 small">How sharp we are. Cognitive horsepower. Largely fixed.</p>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="quotient-card border">
                  <small className="quotient-card-era">1990s</small>
                  <div className="quotient-card-letter text-dark-brand">
                    EQ
                  </div>
                  <small className="quotient-card-label text-muted">Emotional Intelligence</small>
                  <p className="mt-2 mb-0 small">How well we connect. Manage emotions and relationships.</p>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="quotient-card quotient-card--highlight border">
                  <small>Today</small>
                  <div className="quotient-card-letter">PQ</div>
                  <small className="quotient-card-label" style={{ opacity: 0.8 }}>Performance Intelligence</small>
                  <p className="mt-2 mb-0 small font-weight-bold">How well we perform — and sustain it. Trainable, by design.</p>
                </div>
              </div>
            </div>

            <div className="quote-block mb-4">
              <p className="mb-0">
                <strong className="text-dark-brand">Performance Intelligence (PQ)</strong>
                {" is the ability to adapt physical, psychological, and emotional states to optimise performance. Unlike IQ, PQ is trainable — built through deliberate habits specific to energy management, strategic recovery and mental agility."}
              </p>
            </div>

            <p>
              <strong>Why it matters now.</strong>
              {" The world has never been more demanding. The old model — work harder, work longer — is broken. What separates consistently high performers isn't talent or hours. It's the ability to manage energy, think clearly, recover deliberately, and adapt when conditions shift."}
            </p>
          </div>
        </div>

        <div className="dash-row card">
          <div className="card-body">
            <p className="mb-1 text-dark-brand font-weight-bold">How PQ Index measures Performance Intelligence</p>
            <p className="mb-3">The PQ Index measures physical and psychological performance across four domains:</p>
            <table className="table table-bordered domain-table mb-3">
              <tbody>
                {DOMAINS.map(d => (
                  <tr key={d.num}>
                    <td className="text-dark-brand">
                      {d.num}
                    </td>
                    <td>
                      <strong className="text-dark-brand">{d.title}</strong>
                      <br />
                      <small>{d.desc}</small>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="mb-0"><em>Biological Age. Energy Management, Mental Agility, and Strategic Recovery combine to form an overall PQ Score out of 100.</em></p>
          </div>
        </div>

        <div className="dash-row card">
          <div className="card-body">
            <p className="mb-2 text-dark-brand font-weight-bold">How to interpret this report.</p>
            <p className="mb-0">The recommendations in this report are drawn from the habits and behaviours consistently practised by high performers across corporate and elite sporting environments. They are evidence-informed and broadly applicable, a starting point, not a personalised prescription. For recommendations tailored to your specific results, context, and goals, these are developed through Performance Intelligence programs, workshops, keynotes, coaching sessions, and online courses.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutLiveLifeV2
